export default __webpack_public_path__ + "graphics/swimming-pool.7cbed347.jpg";